import { WorkerSafetyOrientationsContainer } from './WorkerSiteSafetyOrientationsContainer';

const name = 'WorkerSafetyOrientationsContainer';

export { WorkerSafetyOrientationsContainer, name };
